import React, { useState, useRef, useEffect } from 'react';
import { useKeycloak } from './KeycloakProvider';
import './UserBadge.css';

const UserBadge = ({ onOpenChange }) => {
  const { user, logout } = useKeycloak();
  const [isExpanded, setIsExpanded] = useState(false);
  const containerRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsExpanded(false);
        if (onOpenChange) {
          onOpenChange(false);
        }
      }
    };

    if (isExpanded) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isExpanded, onOpenChange]);

  if (!user) {
    return null;
  }

  const getInitials = () => {
    if (user.name) {
      const [firstName] = user.name.trim().split(' ').filter(Boolean);
      if (firstName) {
        return firstName.charAt(0).toUpperCase();
      }
    }
    return user.email.charAt(0).toUpperCase();
  };

  const handleLogout = () => {
    logout({ redirectUri: `${window.location.origin}/internal` });
  };

  const toggleExpand = () => {
    setIsExpanded((prev) => {
      const next = !prev;
      if (onOpenChange) {
        onOpenChange(next);
      }
      return next;
    });
  };

  return (
    <div 
      className={`user-badge-container ${isExpanded ? 'expanded' : ''}`}
      ref={containerRef}
    >
      <div className="user-badge">
        <div
          className="user-avatar"
          onClick={toggleExpand}
          title={user.name || user.username}
        >
          {getInitials()}
        </div>
      </div>

      {isExpanded && (
        <div className="user-menu-card">
          <div className="user-menu-header">
            <div className="user-menu-avatar">{getInitials()}</div>
            <div className="user-menu-info">
              <div className="user-menu-name">{user.name || user.username}</div>
              <div className="user-menu-email">{user.email}</div>
            </div>
          </div>

          <div className="user-menu-divider" />

          <button
            className="user-menu-item user-menu-item-button"
            onClick={handleLogout}
            title="Sign Out"
            type="button"
          >
            <span className="user-menu-icon" aria-hidden="true">
              <img src="/icons/logout.png" alt="" />
            </span>
            <span className="user-menu-text">Log out</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default UserBadge;
